import { Button, Result } from 'antd'
import { useState } from 'react'
import type { ReactNode } from 'react'
import { env } from '@/config/env'

interface ErrorStateProps {
  title?: ReactNode
  /** Pass the raw Error object — detail is only shown in dev mode, collapsed. */
  error?: Error
  onRetry?: () => void
}

/** Generic inline error panel (for query/route/boundary failures). */
export function ErrorState({ title = 'Something went wrong.', error, onRetry }: ErrorStateProps) {
  const [expanded, setExpanded] = useState(false)

  return (
    <Result
      status="error"
      title={title}
      subTitle={
        env.isDev && error ? (
          <span>
            <button
              type="button"
              onClick={() => setExpanded((v) => !v)}
              style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, color: 'inherit', textDecoration: 'underline', fontSize: 'inherit' }}
            >
              {expanded ? 'Hide error' : 'Show error'}
            </button>
            {expanded && (
              <pre style={{ marginTop: 8, textAlign: 'left', whiteSpace: 'pre-wrap', wordBreak: 'break-all', fontSize: 12, color: '#cf1322' }}>
                {error.message}
              </pre>
            )}
          </span>
        ) : undefined
      }
      extra={
        onRetry ? (
          <Button type="primary" onClick={onRetry}>
            Try again
          </Button>
        ) : undefined
      }
    />
  )
}
